import { render, staticRenderFns } from "./UserDashboardChart.vue?vue&type=template&id=68df368c&scoped=true"
import script from "./UserDashboardChart.vue?vue&type=script&lang=js"
export * from "./UserDashboardChart.vue?vue&type=script&lang=js"
import style0 from "./UserDashboardChart.vue?vue&type=style&index=0&id=68df368c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68df368c",
  null
  
)

export default component.exports